module.exports = __webpack_public_path__ + "img/Metastasis-CRC_GSE225857.e88a7c84.png";